import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from '@/models/Shared/EntityIdentifier';

export default class GeneralLedgerMappings extends BaseInstitutionEntity {
    createdAtUtc: Date;
    enabled: boolean;
    productId: string;
    productIdentifier: EntityIdentifier;
    savingsFeeIncomeGLCode: number;
    savingsFeeIncomeGLId: string;
    savingsFeeIncomeGLIdentifier: EntityIdentifier;
    savingsInterestExpenseGLCode: number;
    savingsInterestExpenseGLId: string;
    savingsInterestExpenseGLIdentifier: EntityIdentifier;
    savingsInterestPayableGLCode: number;
    savingsInterestPayableGLId: string;
    savingsInterestPayableGLIdentifier: EntityIdentifier;
    savingsPortfolioControlGLCode: number;
    savingsPortfolioControlGLId: string;
    savingsPortfolioControlGLIdentifier: EntityIdentifier;
    state: string;
    transactionSourceGLCode: number;
    transactionSourceGLId: string;
    transactionSourceGLIdentifier: EntityIdentifier;
    updatedAtUtc: Date;
}